// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"437":"88ae02e9","838":"468b48ec","980":"b4a8ae9c"}[chunkId] + ".chunk.css";
};